import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

require('./visit-plan-metric-widget.component.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-visit-plan-metric-widget',
  templateUrl: './visit-plan-metric-widget.component.html',
})
export class VisitPlanMetricWidgetComponent {

  @Input() iconName: string;
  @Input() title: string;
  @Input() iconColor: string = '#125BBA';
  @Input() isStringValue: boolean = false;
  @Input() value: number | string;

  get isValueString(): boolean {
    return this.isStringValue || (typeof this.value === 'string' && isNaN(Number(this.value)));
  }

}

